const PERSONAL_EMAIL_DOMAINS = [
  'gmail',
  'yahoo',
  'hotmail',
  'outlook',
  'live',
  'msn',
  'aol',
  'icloud',
  'me',
  'mac',
  'protonmail',
  'tutanota',
  'mail',
  'yandex',
  'zoho',
  'fastmail',
  'gmx',
  'googlemail',
]

/**
 * Determines if an email is a work email or personal email
 * @param {string} email - The email address to check
 * @returns {boolean} - true if work email, false if personal email
 */
export const isWorkEmail = email => {
  if (!email || typeof email !== 'string') return false
  if (!email.includes('@')) return false
  const normalizedEmail = email.trim().toLowerCase()

  const postAt = normalizedEmail.split('@')[1]
  if (!postAt) return false
  const domain = postAt.split('.')[0]

  return !PERSONAL_EMAIL_DOMAINS.some(
    personalDomain => domain === personalDomain,
  )
}

/**
 * Determines if an email is a personal email
 * @param {string} email - The email address to check
 * @returns {boolean} - true if personal email, false if work email
 */
export const isPersonalEmail = email => {
  return !isWorkEmail(email)
}

/**
 * Gets the user's country based on IP address
 * @returns {Promise<{countryCode: string, countryName: string}>}
 */
export const getUserCountry = async () => {
  try {
    // Get IP address
    const ipResponse = await fetch('https://api.ipify.org?format=json')
    const ipData = await ipResponse.json()

    // Get country info from IP
    const response = await fetch(
      `${process.env.REACT_APP_OPPIZI_IP_INFO_URL}?ip=${ipData.ip}&key=oppizi`,
      {
        method: 'GET',
        headers: {
          'Content-Type': 'application/json',
        },
      },
    )

    const { countryName, countryCode } = await response.json()
    return { countryCode, countryName }
  } catch (error) {
    console.warn('Error detecting user country:', error)
    return { countryCode: 'US', countryName: 'United States' }
  }
}

/**
 * Gets the appropriate email field label based on restrictions
 * @param {string} isEDDMUser - determines if the user landed on the signup page from eddm.com
 * @returns {string} - The label to display for the email field
 */
export const getEmailFieldLabel = isEDDMUser => {
  if (isEDDMUser) {
    return 'Email address'
  }

  return 'Work email'
}
